import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueTypeOptionsHeader: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.issue-type-options.issue-type-options-header',
		defaultMessage: 'Ask AI to suggest child issues. Select an issue type:',
		description: 'Header text for selecting an issue type on the initial step.',
	},
});
